import axios from "axios";
import { omuniReportsV2 } from "../../app/conf";
import { attachResponseInterceptor } from "./interceptors";

const axiosReportsV2Instance = axios.create({
  baseURL: `${omuniReportsV2}/api/v1/reports`,
});

attachResponseInterceptor(axiosReportsV2Instance);

export default axiosReportsV2Instance;
